import { render } from "./notExpired.vue?vue&type=template&id=bc10014e&scoped=true"
import script from "./notExpired.vue?vue&type=script&lang=js"
export * from "./notExpired.vue?vue&type=script&lang=js"

import "./notExpired.vue?vue&type=style&index=0&id=bc10014e&scoped=scoped&lang=less"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc10014e"]])

export default __exports__